var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill":"#85847C","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.927 5.712L6.51.13l.835.835-5.58 5.582z"}}),_c('path',{attrs:{"d":"M12.072 5.712L6.491.132l-.836.835 5.581 5.581z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }